/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Scene_Change_Detection_Cannot_Scan_StatusInputs */

const en_scene_change_detection_cannot_scan_status = /** @type {(inputs: Scene_Change_Detection_Cannot_Scan_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cannot scan video: ${i?.error}`)
};

const fr_scene_change_detection_cannot_scan_status = /** @type {(inputs: Scene_Change_Detection_Cannot_Scan_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossible d'analyser la video : ${i?.error}`)
};

const de_scene_change_detection_cannot_scan_status = /** @type {(inputs: Scene_Change_Detection_Cannot_Scan_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Video konnte nicht gescannt werden: ${i?.error}`)
};

const it_scene_change_detection_cannot_scan_status = /** @type {(inputs: Scene_Change_Detection_Cannot_Scan_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile scansionare il video: ${i?.error}`)
};

const ru_scene_change_detection_cannot_scan_status = /** @type {(inputs: Scene_Change_Detection_Cannot_Scan_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось отсканировать видео: ${i?.error}`)
};

const es_scene_change_detection_cannot_scan_status = /** @type {(inputs: Scene_Change_Detection_Cannot_Scan_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se puede escanear el vídeo: ${i?.error}`)
};

const zh_cn2_scene_change_detection_cannot_scan_status = /** @type {(inputs: Scene_Change_Detection_Cannot_Scan_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`无法扫描视频：${i?.error}`)
};

const ja_scene_change_detection_cannot_scan_status = /** @type {(inputs: Scene_Change_Detection_Cannot_Scan_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ビデオをスキャンできません: ${i?.error}`)
};

const hi_scene_change_detection_cannot_scan_status = /** @type {(inputs: Scene_Change_Detection_Cannot_Scan_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`वीडियो स्कैन नहीं किया जा सकता: ${i?.error}`)
};

const pt_pt2_scene_change_detection_cannot_scan_status = /** @type {(inputs: Scene_Change_Detection_Cannot_Scan_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível digitalizar o vídeo: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Cannot scan video: {error}" |
*
* @param {Scene_Change_Detection_Cannot_Scan_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_cannot_scan_status = /** @type {((inputs: Scene_Change_Detection_Cannot_Scan_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Cannot_Scan_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_cannot_scan_status(inputs)
	if (locale === "de") return de_scene_change_detection_cannot_scan_status(inputs)
	if (locale === "it") return it_scene_change_detection_cannot_scan_status(inputs)
	if (locale === "ru") return ru_scene_change_detection_cannot_scan_status(inputs)
	if (locale === "es") return es_scene_change_detection_cannot_scan_status(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_cannot_scan_status(inputs)
	if (locale === "ja") return ja_scene_change_detection_cannot_scan_status(inputs)
	if (locale === "hi") return hi_scene_change_detection_cannot_scan_status(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_cannot_scan_status(inputs)
	return en_scene_change_detection_cannot_scan_status(inputs)
});